import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";

export default function MarkdownRenderer({ children }) {
  return (
    <div className="markdown-body prose prose-lg max-w-none">
      <ReactMarkdown
        remarkPlugins={[remarkGfm]}
        components={{
          h1: ({ node, ...p }) => <h1 className="font-serif text-4xl tracking-tight mt-10 mb-4" {...p} />,
          h2: ({ node, ...p }) => <h2 className="font-serif text-3xl tracking-tight mt-10 mb-4" {...p} />,
          h3: ({ node, ...p }) => <h3 className="font-serif text-2xl tracking-tight mt-8 mb-3" {...p} />,
          p: ({ node, ...p }) => <p className="text-base sm:text-lg leading-relaxed my-5 text-foreground/90" {...p} />,
          ul: ({ node, ...p }) => <ul className="list-disc pl-6 space-y-2 my-5 text-foreground/90" {...p} />,
          ol: ({ node, ...p }) => <ol className="list-decimal pl-6 space-y-2 my-5 text-foreground/90" {...p} />,
          li: ({ node, ...p }) => <li className="leading-relaxed" {...p} />,
          a: ({ node, ...p }) => <a className="link-underline text-accent" target="_blank" rel="noreferrer" {...p} />,
          blockquote: ({ node, ...p }) => (
            <blockquote className="border-l-2 border-accent pl-6 my-6 italic text-muted-foreground font-serif text-xl" {...p} />
          ),
          code: ({ inline, ...p }) =>
            inline ? (
              <code className="font-mono text-sm bg-secondary px-1.5 py-0.5 rounded" {...p} />
            ) : (
              <code className="block font-mono text-sm bg-secondary p-4 rounded-lg overflow-x-auto my-5" {...p} />
            ),
          hr: () => <hr className="my-10 border-border" />,
          strong: ({ node, ...p }) => <strong className="text-foreground font-semibold" {...p} />,
        }}
      >
        {children || ""}
      </ReactMarkdown>
    </div>
  );
}
